<template>
  <div class="share-container">
    <div class="title">
      产品信息
    </div>
    <template v-for="item in detail">
      <GoodsInfoItem :key="item.id" :info="item" />
    </template>
  </div>
</template>

<script>
import GoodsInfoItem from './OrderGoodsInfoItem.vue'
export default {
  components: {
    GoodsInfoItem
  },
  props: {
    detail: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
.share-container {
  background-color: #fff;
  .title {
    font-size: 16px;
    font-weight: 600;
    margin-top: 2vh;
    margin-left: 4vw;
    border-left: 2vw solid #014492;
    padding-left: 2vw;
    color: #1d2c36;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/share/confirm-order/components/OrderGoodsInfo.vue